// extracted by mini-css-extract-plugin
export const button = "gdpr-module--button--2JOBl";
export const content = "gdpr-module--content--2jqEy";